const getTimeBlocks = async (feedTimeBlocksUrl, hours, jumpers, eventType, date, park) => {
    let action = `${feedTimeBlocksUrl}?park=${encodeURI(park)}&jumpers=${encodeURI(jumpers)}&duration=${encodeURI(hours)}&type=${encodeURI(eventType)}&date=${encodeURI(date)}`;
    const settings = {
        method: 'GET',
    };
    const response = await fetch(action, settings);
    if (!response.ok) throw Error(response.message);

    try {
        return await response.json();
    } catch (err) {
        throw err;
    }
};

export default getTimeBlocks;